'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Field = exports.withFormValue = exports.suppressUpdate = exports.createValue = exports.ErrorList = exports.Input = exports.Schema = exports.Fieldset = exports.update = exports.validate = undefined;

var _Schema2 = require('./Schema');

Object.defineProperty(exports, 'validate', {
  enumerable: true,
  get: function get() {
    return _Schema2.validate;
  }
});

var _update = require('./update');

Object.defineProperty(exports, 'update', {
  enumerable: true,
  get: function get() {
    return _update.update;
  }
});

var _Value = require('./Value');

Object.defineProperty(exports, 'createValue', {
  enumerable: true,
  get: function get() {
    return _Value.create;
  }
});
Object.defineProperty(exports, 'suppressUpdate', {
  enumerable: true,
  get: function get() {
    return _Value.suppressUpdate;
  }
});
exports.WithFormValue = WithFormValue;
exports.Value = Value;

var _noop = require('lodash/noop');

var _noop2 = _interopRequireDefault(_noop);

var _withFormValue2 = require('./withFormValue');

var _withFormValue3 = _interopRequireDefault(_withFormValue2);

var _Fieldset2 = require('./Fieldset');

var _Fieldset3 = _interopRequireDefault(_Fieldset2);

var _Schema = _interopRequireWildcard(_Schema2);

var _Input2 = require('./Input');

var _Input3 = _interopRequireDefault(_Input2);

var _ErrorList2 = require('./ErrorList');

var _ErrorList3 = _interopRequireDefault(_ErrorList2);

var _Field2 = require('./Field');

var _Field3 = _interopRequireDefault(_Field2);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Fieldset = _Fieldset3.default;
exports.Schema = _Schema;
exports.Input = _Input3.default;
exports.ErrorList = _ErrorList3.default;
exports.withFormValue = _withFormValue3.default;
exports.Field = _Field3.default;
function WithFormValue() {
  console.warn('react-forms - Deprecation notice: WithFormValue(..) has been renamed to withFormValue(..)'); // eslint-disable-line no-console
  return _withFormValue3.default.apply(undefined, arguments);
}

function Value(schema) {
  var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var onChange = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _noop2.default;
  var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var errorList = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;

  console.warn('react-forms - Deprecation notice: Value(schema, value, onChange, params, errorList) has been refactored to createValue(options)'); // eslint-disable-line no-console
  return (0, _Value.create)({ schema: schema, value: value, onChange: onChange, params: params, errorList: errorList });
}
